import { combineReducers } from "redux";
import NotificationReducer from "./NotificationReducer";
import User from "./User";
import Catalog from "./Catalog";
import ManualOrderReducer from "./manualOrder";
import DealReducer from "./dealReducer";
import uiReducer from "./uiReducer";
import menuReducer from "./menuReducer";

const RootReducer = combineReducers({
  NotificationReducer,
  User,
  Catalog,
  ManualOrderReducer,
  DealReducer,
  ui: uiReducer,
  menu: menuReducer,
});

export default RootReducer;
